export default __webpack_public_path__ + "static/media/image32.6ba99635.png";